import React from "react";
import { useTranslation } from "react-i18next";
import FileImport from "components/import/FileImport";
import { DatasetImport } from "network/wineImport";

const DatasetImportPage = () => {
  const { t } = useTranslation("wine");
  return (
    <FileImport
      title={t("import.dataset.title")}
      intro={t("import.dataset.intro")}
      columnsHelp={t("import.dataset.columnsHelp")}
      api={DatasetImport}
      templateName="modello_wine_data.csv"
      statuses={{ created: [t("import.dataset.statusCreated"), "success"], skipped: [t("import.dataset.statusSkipped"), "secondary"], error: [t("import.dataset.statusError"), "danger"] }}
      counters={[["created", t("import.dataset.counterCreated")], ["skipped", t("import.dataset.counterSkipped")], ["errors", t("import.dataset.counterErrors")]]}
      confirmLabel={t("import.dataset.confirm")}
      doneHint={t("import.dataset.doneHint")}
    />
  );
};

export default DatasetImportPage;
